import axios from 'axios';
import {GlobalUtility} from '../../service/global-utility.service';
import {
  CREW,
  CREW_PCRS,
  DELETE_PCR,
  PCR,
  PCR_DETAILS,
} from '@/service/constants.service';

const state ={
  files:[],
  file:{},
  pcrFile: {},
  pcrDetails: {},
};


const mutations = {
  set_files : (state,params) =>{
    state.files = params;
  },

  set_file : (state,param) =>{
    state.file = param;
  },

  set_pcrFile : (state, param) =>{
    state.pcrFile = param;
  },

  delete_pcrFile : (state, param) => {
    state.pcrFile = param;
  },

  set_pcrDetails: (state, param) => {
    state.pcrDetails = param;
  }


}

const actions = {
  async uploadCov19MedCert({commit},params){
    return await axios({
      method : `post`,
      url : '/uploadCov19MedCert',
      data : params
    }).then((response)=>{
      return true;
    }).catch((errors)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(errors,'Upload Cov19 Med-Cert');
      return false;
    });
  },

  async getPCRFile({commit}, param){
    return await axios.post(PCR,param).then((response)=>{
      commit('set_pcrFile',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get PCR');
      return false;
    });
  },

  async deletePCRFile({commit}, param){
    return await axios.delete(`${DELETE_PCR}/${param}`).then((response)=>{
      commit('delete_pcrFile',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'DELETE PCR FILE');
      return false;
    });
  },

  async getPCRDetails({commit}, param){
    return await axios.get(`${PCR_DETAILS}/${param}`).then((response)=>{
      commit('set_pcrDetails',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get PCR Details');
      return false;
    });
  },

  async updateCov19MedCert({commit},params){
    return await axios({
      method : `post`,
      url : '/updateCov19medCert',
      data : params
    }).then((response)=>{
      return true;
    }).catch((errors)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(errors,'Update Cov19 Med-Cert');
      return false;
    });
  },

}


const getters = {
  files : state => state.files,
  file : state => state.file,
  pcrFile: state => state.pcrFile,
  pcrDetails: state => state.pcrDetails,
}

export default {state, actions, mutations, getters};